import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { OnInit } from '@angular/core';
import { SafeValue, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'site-videoEmbeded',
  templateUrl: './videoEmbeded.component.html',
  styleUrls: ['./videoEmbeded.component.css']
})
export class EmbededVideoComponent implements OnInit {
  @Input()
  videoEmbedHTML: string;
  safeUrl: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer){
  }

  ngOnInit(): void{
    console.log(this.videoEmbedHTML);
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoEmbedHTML);
  }
  
}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/components/videoEmbeded/videoEmbeded.component.ts